var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#32CCCC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2083 21.1667C17.6581 21.1667 18.8333 22.3419 18.8333 23.7917V27.875C18.8333 29.3247 17.6581 30.5 16.2083 30.5H12.125C10.6753 30.5 9.5 29.3247 9.5 27.875V23.7917C9.5 22.3419 10.6753 21.1667 12.125 21.1667H16.2083ZM27.875 21.1667C29.3247 21.1667 30.5 22.3419 30.5 23.7917V27.875C30.5 29.3247 29.3247 30.5 27.875 30.5H23.7917C22.3419 30.5 21.1667 29.3247 21.1667 27.875V23.7917C21.1667 22.3419 22.3419 21.1667 23.7917 21.1667H27.875ZM16.2083 9.5C17.6581 9.5 18.8333 10.6753 18.8333 12.125V16.2083C18.8333 17.6581 17.6581 18.8333 16.2083 18.8333H12.125C10.6753 18.8333 9.5 17.6581 9.5 16.2083V12.125C9.5 10.6753 10.6753 9.5 12.125 9.5H16.2083ZM27.875 9.5C29.3247 9.5 30.5 10.6753 30.5 12.125V16.2083C30.5 17.6581 29.3247 18.8333 27.875 18.8333H23.7917C22.3419 18.8333 21.1667 17.6581 21.1667 16.2083V12.125C21.1667 10.6753 22.3419 9.5 23.7917 9.5H27.875Z",
    fill: "#32CCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecIcon1);
export default __webpack_public_path__ + "static/media/secIcon1.312544ed6046b648fd1b79e2ae27fbda.svg";
export { ForwardRef as ReactComponent };